/* eslint-disable @typescript-eslint/no-base-to-string */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { Badge, Button, Modal } from 'antd';
import '../shipment/ShipmentTrack.css';
import './movement.less';
import '../shipment/Support.css';
import '../receptionStore/receptionView/ReceptionView.less';
import { useAuth } from '@isocel/front-common';
import { useHistory, useParams } from 'react-router-dom';
import { CloudUploadOutlined, LeftOutlined, MessageOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';

import { usePackagingConfig } from '../../queries/package';
import { DocumentTypes, PackagingFlowDirection, PackagingFlowItem } from '../../queries/api/types';
import { usePackagingFlow } from '../../context/PackagingFlowContext';
import { createPackagingFlow, downloadPackagingVoucher } from '../../queries/api/packaging-flow';
import { ShipmentSuccess } from '../shipment';
import { isFileValid, printPDF } from '../../utils/utils';
import { useNotification } from '../notification/Notification';
import UploadDocument from '../uploadDocuments/UploadDocuments';
import defaultImage from '../../assets/images/default.png';
import { PALLET_MOVEMENT_FLOW_TYPES, SENDER_RECEIVER_MOVEMENT_TYPES } from '../../constants';

const RecipientMovement: React.FC = () => {
    const { data: packageConfig } = usePackagingConfig();
    const [loading, setLoading] = useState(false);
    const {
        recipientLabel,
        loadingSession,
        voucher,
        transporterId,
        packageFlow,
        setPackageFlow,
        flowType,
        supplierId,
        movementType,
        selectedProvider,
        selectedParc,
        transporterName,
        supplierName,
        updateComment,
        setUpdateComment,
        setPackageToEdit,
        setIsPackageToEdit,
        setIsModifierClicked,
        uploadedFiles,
        selectedSender,
        selectedReciever,
    } = usePackagingFlow();
    const { user } = useAuth();
    const [comment, setComment] = useState<string>('');
    const [selectedVoucherId, setSelectedVoucherId] = useState<string | null>(null);
    const [isCommentModalVisible, setIsCommentModalVisible] = useState(false); // For the comment modal
    const [isPrintModalVisible, setIsPrintModalVisible] = useState(false); // For the printing modal
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const history = useHistory();
    const { showNotification } = useNotification();
    const { storeId } = useParams<{ storeId: string }>();
    const [isPallateMovement, setPallateMovement] = useState(false);
    const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
    useEffect(() => {
        if (packageFlow) {
            const flowMap: Record<string, PackagingFlowItem> = {};
            packageFlow.flowType = flowType;
            packageFlow.packages.forEach((pkg) => {
                flowMap[String(pkg.package)] = {
                    package: pkg.package,
                    shippedQuantity: pkg.shippedQuantity,
                    goodCount: pkg.goodCount,
                    badCount: pkg.badCount,
                };
            });
        }

        const pallateMovement = PALLET_MOVEMENT_FLOW_TYPES.includes(flowType);
        setPallateMovement(pallateMovement);
        setComment(updateComment || '');
    }, [packageFlow, flowType, updateComment]);

    const handleSave = async () => {
        if (loading) return; // Prevent multiple clicks
        setLoading(true);
        try {
            const invalidFiles = isFileValid(uploadedFiles);
            if (invalidFiles.length > 0) {
                const firstInvalid = invalidFiles[0];
                showNotification(
                    'error',
                    'Type de fichier non autorisé',
                    `Le fichier suivant n'est pas autorisé : ${firstInvalid.file.name} (${firstInvalid.file.type})`
                );
                setLoading(false);
                return;
            }
            const formData = new FormData();
            uploadedFiles.forEach((uploadedFile) => {
                formData.append('file', uploadedFile.file);
            });
            let sender, recipient, senderType, recieverType;
            if ([PackagingFlowDirection.Purchase, PackagingFlowDirection.ReceptionFromRepair].includes(flowType)) {
                recipient = selectedParc?.id;
                sender = selectedProvider?.id;
            } else if ([PackagingFlowDirection.Sale, PackagingFlowDirection.ShipmentForRepair].includes(flowType)) {
                sender = selectedParc?.id;
                recipient = selectedProvider?.id;
            } else if (
                [
                    PackagingFlowDirection.Transfer,
                    PackagingFlowDirection.Increase,
                    PackagingFlowDirection.Decrease,
                ].includes(flowType)
            ) {
                sender = selectedSender?.id || selectedSender?._id;
                recipient = selectedReciever?.id || selectedReciever?._id;
                senderType = selectedSender?.SelectionType;
                recieverType = selectedReciever?.SelectionType;
            } else if (flowType === PackagingFlowDirection.Destruction) {
                sender = selectedParc?.id;
                recipient = selectedParc?.id;
            } else if (packageFlow) {
                const { flowType } = packageFlow;
                if ([PackagingFlowDirection.RecivedInStore, PackagingFlowDirection.ShippedToStore].includes(flowType)) {
                    sender = user?.organization?.id;
                    recipient = storeId;
                } else if ([PackagingFlowDirection.ShippedToOrganization].includes(flowType)) {
                    recipient = user?.organization?.id;
                    sender = storeId;
                } else if ([PackagingFlowDirection.RecivedInOrganization].includes(flowType)) {
                    recipient = selectedParc?.id;
                    sender = storeId;
                } else {
                    sender = supplierId;
                    recipient = storeId;
                }
            }
            if (sender && recipient) {
                const req = {
                    senderType,
                    recieverType,
                    originId: packageFlow?._id || packageFlow?.id,
                    user: user?.id || '',
                    loadingSession: loadingSession ? loadingSession.id : null,
                    transportVoucher: voucher,
                    transporter: transporterId || undefined,
                    flowType: packageFlow?.flowType || 0,
                    sender,
                    recipient,
                    comment: comment,
                    organization: user?.organization?.id,
                    packages: (packageFlow?.packages || [])
                        .map((pkg) => ({
                            ...pkg,
                            shippedQuantity:
                                flowType === PackagingFlowDirection.ShippedToOrganization
                                    ? pkg.goodCount + pkg.badCount
                                    : pkg.shippedQuantity,
                        }))
                        .filter((pkg) => pkg.goodCount > 0 || pkg.badCount > 0 || pkg.shippedQuantity > 0),
                    attachments: uploadedFiles.map((uploadedFile) => ({
                        attachmentType: uploadedFile.type as DocumentTypes,
                    })),
                };
                setPackageFlow(req);
                try {
                    const pkg = packageFlow?.packages.filter((pkg) => pkg.goodCount > 0 || pkg.badCount > 0);
                    if ((pkg ?? []).length > 0) {
                        const files = uploadedFiles.map((uploadedFile) => uploadedFile.file);
                        const response = await createPackagingFlow(req, files);
                        if (response) {
                            if (flowType === PackagingFlowDirection.ReceivedFromSupplier) {
                                const voucherId = response.packagingVouchers?.[0];
                                if (voucherId) {
                                    setSelectedVoucherId(voucherId as unknown as string);
                                    setIsPrintModalVisible(true);
                                } else {
                                    // Find packageConfigItems for each pkg in packageFlow
                                    const allRental = packageFlow?.packages.every((pkg) => {
                                        const configItem = packageConfig?.packages.find((p) => p.id === pkg.package);
                                        return configItem?.rental;
                                    });
                                    const allBad = packageFlow?.packages
                                        .filter((pkg) => {
                                            const configItem = packageConfig?.packages.find(
                                                (p) => p.id === pkg.package
                                            );
                                            return configItem && !configItem.rental;
                                        })
                                        .every((pkg) => pkg.goodCount === 0);
                                    if (allRental || allBad) {
                                        setIsPrintModalVisible(false);
                                        setIsSuccess(true);
                                    }
                                }
                            } else {
                                setIsSuccess(true);
                            }
                        }
                    } else {
                        showNotification('error', "Échec de l'analyse", `Veuillez saisir au moins un emballage.`);
                    }
                } catch (error) {
                    console.error('Error posting shipment data:', error);
                }
            }
        } finally {
            setLoading(false);
        }
    };
    const showUploadModal = () => {
        setIsUploadModalVisible(true);
    };
    const handlePrint = async () => {
        if (!selectedVoucherId) return;
        const response = await downloadPackagingVoucher(selectedVoucherId);
        await printPDF(
            new Blob([response.data], { type: 'application/pdf' }),
            () => {
                setIsPrintModalVisible(false);
                setIsSuccess(true);
            },
            () => {
                showNotification('error', "Erreur lors de l'impression du bon d'emballage", '');
            },
            () => {
                setTimeout(() => {
                    setIsSuccess(true);
                }, 2000);
            }
        );
    };

    if (isSuccess) {
        return <ShipmentSuccess />;
    }

    const handleBack = async () => {
        setIsModifierClicked(true);
        history.push(`/recipientTrack/${storeId}`);
        setPackageFlow(packageFlow);
        setUpdateComment(comment);
        setPackageToEdit(null);
    };
    const change = (value: string) => {
        setComment(value);
    };
    const showModal = () => {
        setIsCommentModalVisible(true);
    };

    const onItemClick = (pkg: PackagingFlowItem) => {
        const packageConfigItem = packageConfig?.packages.find((configPkg) => configPkg.id === pkg.package);

        if (packageConfigItem) {
            const data = {
                key: `${pkg.package}-${packageConfigItem.type.name}`,
                typeName: packageConfigItem.type.name,
                id: pkg.package,
                shippedQuantity: pkg.shippedQuantity,
                model: {
                    id: packageConfigItem.model.id,
                    name: packageConfigItem.model.name,
                },
                category: {
                    id: packageConfigItem.category.id,
                    name: packageConfigItem.category.name,
                },
                type: {
                    id: packageConfigItem.type.id,
                    name: packageConfigItem.type.name,
                    image: packageConfigItem.type.image,
                },
            };

            setPackageToEdit(data);
            setIsPackageToEdit(true);
            history.push(`/recipientTrack/${storeId}`);
        }
    };
    const renderPackages = () => {
        return packageFlow?.packages
            .filter((pkg) => pkg.goodCount > 0 || pkg.badCount > 0 || pkg.shippedQuantity > 0) // Filter packages with goodCount or badCount > 0
            .map((pkg, i) => {
                const packageConfigItem = packageConfig?.packages.find((configPkg) => configPkg.id === pkg.package);
                const typeName = packageConfigItem?.type.name || 'Unknown Type';
                const modelName = packageConfigItem?.model.name || 'Unknown Model';
                return (
                    <div className="tab-panel" key={i}>
                        <div
                            className="package-item"
                            role="button"
                            tabIndex={0}
                            onClick={() => onItemClick(pkg)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    onItemClick(pkg); // Handle Enter or Space key for accessibility
                                }
                            }}
                        >
                            <div className="session-box align-flex flex direction items-center">
                                <div className="flex direction">
                                    <div className="flex items-center">
                                        <img
                                            src={packageConfigItem?.type?.image || defaultImage}
                                            alt={packageConfigItem?.type?.name}
                                            className="header-type-image"
                                        />
                                        <h3>
                                            <strong>{typeName}</strong>
                                            {typeName !== modelName && ` - ${modelName}`}
                                        </h3>
                                        <span className="tag tag-grey">
                                            {' '}
                                            {pkg.goodCount + pkg.badCount || 0} palettes
                                        </span>
                                    </div>
                                </div>
                                <div className="p-4 py-16">
                                    <strong>{pkg.goodCount || 0}</strong> <span>Bon état</span> &nbsp; &nbsp;{' '}
                                    <strong>{pkg.badCount || 0}</strong> <span>Cassée</span>
                                    <span className="right-arrow">
                                        {' '}
                                        <RightOutlined />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
    };

    return (
        <>
            <div className="title mb-16">
                <LeftOutlined className="back-icon" onClick={() => history.goBack()} />
            </div>
            <div className="reception-view has-comment support-container bg-dash ">
                <header className="header">
                    <div className="location">
                        {movementType && SENDER_RECEIVER_MOVEMENT_TYPES.includes(movementType.name) ? (
                            <>
                                <p>{movementType?.label}</p>
                                <p>Émetteur: {selectedSender?.name}</p>
                                <p>Destinataire: {selectedReciever?.name}</p>
                            </>
                        ) : isPallateMovement ? (
                            <>
                                <p>{movementType?.label}</p>
                                <p>Prestataire: {selectedProvider?.name}</p>
                                <p>Parc palettes: {selectedParc?.name}</p>
                            </>
                        ) : (
                            <>
                                {recipientLabel && <p>Destinataire: {recipientLabel}</p>}
                                {supplierName && <p>Transporteur : {supplierName}</p>}
                                {transporterName && <p>Fournisseur: {transporterName}</p>}
                                {voucher && <p>Bon de transport: {voucher}</p>}
                            </>
                        )}
                    </div>
                </header>
                <h3 className="support">Supports & Emballages</h3>
                {renderPackages()}
            </div>
            <div className="bottom flex flex-col">
                {(flowType === PackagingFlowDirection.RecivedInStore ||
                    flowType === PackagingFlowDirection.RecivedInOrganization ||
                    flowType === PackagingFlowDirection.ShippedToOrganization ||
                    flowType === PackagingFlowDirection.ReceivedFromSupplier) && (
                    <>
                        {packageFlow?.comment ? (
                            <div className="floating-button">
                                <CloudUploadOutlined
                                    className="upload-icon mr-16 text-blue"
                                    onClick={showUploadModal}
                                />
                                <Badge count={1} offset={[-5, 5]}>
                                    <Button
                                        type="primary"
                                        shape="circle"
                                        icon={<MessageOutlined />}
                                        onClick={showModal}
                                    />
                                </Badge>
                            </div>
                        ) : (
                            <CloudUploadOutlined className="upload-icon text-blue" onClick={showUploadModal} />
                        )}
                    </>
                )}
                <div className="comment-section">
                    <h4>Commentaire</h4>
                    <textarea
                        placeholder="Remarque sur un support"
                        value={comment}
                        onChange={(e) => change(e.target.value)}
                    ></textarea>{' '}
                </div>
                <footer>
                    <div className="action-buttons flex justify-center">
                        <Button onClick={handleBack}>Modifier</Button>
                        <Button
                            type="primary"
                            onClick={handleSave}
                            className="ml-16"
                            disabled={loading} // Disable while loading
                            loading={loading}
                        >
                            Valider
                        </Button>
                    </div>
                </footer>
            </div>
            <Modal
                title="Commentaires"
                visible={isCommentModalVisible}
                onCancel={() => setIsCommentModalVisible(false)}
                footer={null}
                getContainer={false}
                className="custom-modal"
            >
                <div className="modal-textarea bg-light-blue ">
                    <div>{packageFlow?.comment || ''}</div>
                    {packageFlow?.createdAt && (
                        <div className="creation-date text-primary">
                            {`${moment(packageFlow.createdAt).format('DD/MM/YYYY')} ${moment(
                                packageFlow.createdAt
                            ).format('HH:mm')}`}
                        </div>
                    )}
                </div>
            </Modal>
            {/* Modal for Printing */}
            <Modal
                title="Imprimer le nouveau bon d'emballages"
                visible={isPrintModalVisible}
                closable={false}
                maskClosable={false}
                footer={[
                    <Button key="print" type="primary" onClick={handlePrint}>
                        Imprimer
                    </Button>,
                ]}
            >
                <p>Veuillez imprimer le bon d&apos;emballages et le restituer au transporteur</p>
            </Modal>
            <Modal
                title="Télécharger des documents"
                visible={isUploadModalVisible}
                onCancel={() => {
                    setIsUploadModalVisible(false);
                }}
                footer={null}
                bodyStyle={{ padding: '10px' }}
            >
                <div>
                    <UploadDocument />
                    <div className="mt-8 flex justify-center">
                        <Button
                            type="primary"
                            onClick={() => {
                                setIsUploadModalVisible(false);
                            }}
                        >
                            Suivant
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default RecipientMovement;
